import script from "./sf-accordion.ce.vue?vue&type=script&lang=ts&setup=true"
export * from "./sf-accordion.ce.vue?vue&type=script&lang=ts&setup=true"

import _style_0 from "./sf-accordion.ce.vue?vue&type=style&index=0&id=01adf9b1&inline&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['styles',[_style_0]],['__scopeId',"data-v-01adf9b1"]])

export default __exports__